/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'
import { campaignAddonWithPriceDataNameSchema } from './CampaignAddonWithPriceDataNameSchema'

export const campaignAddonWithPriceDataSchema = z.object({
	id: z.string(),
	name: campaignAddonWithPriceDataNameSchema,
	price: z.number(),
})

export type CampaignAddonWithPriceDataSchema = z.infer<typeof campaignAddonWithPriceDataSchema>
